import React from 'react';
import { TrendingUp, Lock, Users, Flame } from 'lucide-react';
import { mockData } from '../mock/mockData';

const About = () => {
  const { about } = mockData;

  const iconMap = {
    0: <TrendingUp size={32} />,
    1: <Flame size={32} />,
    2: <Users size={32} />,
    3: <Lock size={32} />
  };

  return (
    <section id="about" className="about-section">
      <div className="section-container">
        <h2 className="section-title">{about.title}</h2>
        <p className="section-description">{about.description}</p>

        <div className="stats-grid">
          {about.stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">
                {iconMap[index]}
              </div>
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
